/**
 * Product info accordions: only one open at a time.
 */
(function () {
  function closeOthers(group, opened) {
    group.querySelectorAll('accordion-disclosure.accordion.is-open').forEach((acc) => {
      if (acc === opened) return;
      const summary = acc.querySelector('.accordion__summary');
      if (summary) summary.click();
    });
  }

  function bind(root) {
    if (root.dataset.exclusiveBound) return;
    root.dataset.exclusiveBound = 'true';

    root.addEventListener('click', (event) => {
      const summary = event.target.closest('.accordion__summary');
      if (!summary || !root.contains(summary)) return;

      const opened = summary.closest('accordion-disclosure.accordion');
      if (!opened || !opened.classList.contains('is-open')) return;

      const group = opened.closest('.accordion-group') || root;
      closeOthers(group, opened);
    });
  }

  function init() {
    document.querySelectorAll('.shopify-section--main-product').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
